/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';

import { TrelloStorage } from '@trello/storage';

const MAX_RECENT = 10;

class Recents {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _getKey(type: any) {
    return `recent_${type}`;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  add(type: any, value: any) {
    // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
    const current = this.get(type);
    const newValue = _.chain([value, ...Array.from(current)])
      .uniq()
      .first(MAX_RECENT)
      .value();

    return TrelloStorage.set(this._getKey(type), newValue);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get(type: any, count: any) {
    let left;
    if (count == null) {
      count = MAX_RECENT;
    }
    return _.chain(
      (left = TrelloStorage.get(this._getKey(type))) != null ? left : [],
    )
      .compact()
      .first(count)
      .value();
  }
}

// eslint-disable-next-line @trello/no-module-logic
const recents = new Recents();
export { recents as Recents };
